export default function ElectricHammer(props: any) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9728_20408)">
                <path d="M6.75 5.625V11.25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.75 6.75H12.375" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.75 10.125H12.375" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M29.25 11.3105L29.25 5.625" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M29.25 10.125H23.625" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M29.25 6.75H23.625" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.1641 7.05908V11.3104" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M19.8359 7.05908V11.3104" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.875 23.625H19.125V16.875H16.875V23.625Z"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M16.875 30.375C16.875 30.9963 17.3787 31.5 18 31.5V31.5C18.6213 31.5 19.125 30.9963 19.125 30.375V23.625H16.875V30.375Z"
                    fill="black"
                />
                <path
                    d="M26.4988 23.4351L23.3101 26.6238L24.5838 27.8974L21.7656 30.7162"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M9.55469 23.1885L12.7434 26.3767L11.4698 27.6509L14.2885 30.4696"
                    stroke="black"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M12.375 5.0625C12.375 4.75184 12.6268 4.5 12.9375 4.5H23.0625C23.3732 4.5 23.625 4.75184 23.625 5.0625V12.5048C23.625 12.8155 23.3731 13.0673 23.0624 13.0673C22.4593 13.0673 21.9782 13.0673 21.3751 13.0673C21.0644 13.0673 20.8125 13.3191 20.8125 13.6298V16.3125C20.8125 16.6232 20.5607 16.875 20.25 16.875H15.75C15.4393 16.875 15.1875 16.6232 15.1875 16.3125V13.6298C15.1875 13.3191 14.9357 13.0673 14.625 13.0673H12.9375C12.6268 13.0673 12.375 12.8155 12.375 12.5048V5.0625Z"
                    stroke="black"
                    stroke-width="1.5"
                />
            </g>
            <defs>
                <clipPath id="clip0_9728_20408">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
